import { replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '../../../../../../common-utils/libraries/axios/axios';
import USERS from '../apiUrls';
import userFields from '../../fields/userFields';

/**
 * @param responseData response.data object
 * @param responseData.uuid string
 * @param responseData.email string
 * @param responseData.roles string
 * @param responseData.organization string
 * @param responseData.createdAt string
 * @param responseData.updatedAt string
 * @param responseData.lastLoginAt string
 * @param responseData.permissionList array
 * @param responseData.profileName string
 * @param responseData.hasMfa boolean
 * @param responseData.status string
 *
 * @param response
 * @returns Mapped data object
 */
function mapResponseData(response) {
    const data = {
        [userFields.UUID.key]: response[userFields.UUID.key],
        [userFields.EMAIL.key]: response[userFields.EMAIL.key],
        [userFields.PROFILE.key]: response[userFields.PROFILE.key],
        [userFields.ADVANCED_AUTH.key]: response[userFields.ADVANCED_AUTH.key],
        [userFields.ORGANIZATION_UUID.key]: response[userFields.ORGANIZATION_UUID.key],
        [userFields.STATUS.key]: response[userFields.STATUS.key],
        [userFields.CREATED_AT.key]: response[userFields.CREATED_AT.key],
        [userFields.UPDATED_AT.key]: response[userFields.UPDATED_AT.key],
        [userFields.LAST_LOGIN_AT.key]: response[userFields.LAST_LOGIN_AT.key],
        [userFields.PERMISSIONS.key]: response[userFields.PERMISSIONS.key],
        [userFields.ROLES.key]: response[userFields.ROLES.key]
    };
    return data;
}

const queryGetUser = (userId) => {
    return {
        queryKey: [USERS.DETAILS.queryKey, userId],
        queryFn: async () => {
            const response = await client.get(replaceParameters(USERS.DETAILS.url, { userId }));
            return mapResponseData(response.data);
        }
    };
};

export default queryGetUser;